import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-050d7e13"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "courseGuide" };
const _hoisted_2 = { class: "bannerWrapper" };
const _hoisted_3 = {
    alt: "",
    style: { "width": "100%" }
};
const _hoisted_4 = { class: "courseMsg p-lr32 border-box p-t32" };
const _hoisted_5 = { class: "courseName font-44 font-w500 m-b20" };
const _hoisted_6 = { class: "flexBox infoBox" };
const _hoisted_7 = { class: "expertInfo flex-center" };
const _hoisted_8 = { class: "expertImg" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "text-overflow" };
const _hoisted_11 = { class: "expertName font-28 text-overflow" };
const _hoisted_12 = { class: "hospital gray-9 font-24 text-overflow" };
const _hoisted_13 = { class: "btn gray-9 font-28" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "info" };
const _hoisted_17 = { class: "expertDesc font-28 p-t16 p-b32" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
    key: 0,
    class: "courseImg p-b20"
};
const _hoisted_20 = { alt: "" };
const _hoisted_21 = { class: "courseFooterWrapper" };
const _hoisted_22 = { class: "courseFooter flexBox border-box p-lr32" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = ["onClick"];
import { nextTick, ref, watch, onMounted, onUnmounted, computed } from 'vue';
import Banner from '@/components/common/Banner.vue';
import AppShareItem from '@/components/common/AppShare.vue';
import { getCourseGuide } from '@/api/video';
import CourseRecommend from '@/components/course/courseRecommend.vue';
import { appPort, getUserId, jumpModuleApp, weixinShare, appFullScreen, goToStudy, PCPort, mathRound, recommendGIO, iOSPort, userLogin } from '@/widget/index';
import { createAlbumOrder } from '@/api/video';
// import Player from '@com/common/Player.vue'
import { hostPath, hostPCPath } from '@/public/utils/basePath';
import { useRoute } from 'vue-router';
import { useAppPageBar } from '@/hooks/appPage';
import { bannerShareInfo } from '@/api/home';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    props: {
        updatePage: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const { getRemH } = useAppPageBar();
        const isApp = appPort();
        const route = useRoute();
        const courseId = String(route.params.id);
        const courseType = String(route.params.type);
        let isLiveOpen = false;
        if (String(route.query.is_live_open) === '1') {
            isLiveOpen = true;
        }
        if (!/(album|omo|online|meeting)/.test(courseType)) {
            location.assign('/');
        }
        if (!/^\d+$/.test(String(courseId))) {
            location.assign('/');
        }
        if (isApp && !isLiveOpen) {
            appFullScreen();
        }
        let userId = getUserId();
        const bannerStyle = {
            height: '4.22rem',
            width: '7.5rem'
        };
        // 讲师介绍展开
        const expertBl = ref(false);
        const courseDetail = ref({});
        const banner = ref([]);
        const moduleType = ref('album');
        const loaded = ref(false);
        const shareInfo = ref({});
        let bannerShare = ref(false);
        const desc = computed(() => {
            if (bannerShare.value) {
                return shareInfo.value.desc;
            }
            return (courseDetail.value.expertName + '\n' + courseDetail.value.expertHospitalName);
        });
        // 分享设置
        let qLocation = route.query.location || '';
        let bannerId = route.query.bannerId || '';
        if (qLocation == 'banner' && bannerId && isApp) {
            bannerShareInfo(String(bannerId)).then((res) => {
                if (res.code == 200) {
                    bannerShare.value = true;
                    shareInfo.value = res.data;
                }
            });
        }
        const getData = () => {
            getCourseGuide('album', courseId, { userId }).then((res) => {
                if (res.code == 200) {
                    courseDetail.value = res.data;
                    banner.value = res.data.albumCarousel;
                    document.title = courseDetail.value.albumName;
                    moduleType.value = courseDetail.value.moduleType;
                    if (PCPort()) {
                        location.replace(`${hostPCPath}/web/video/${moduleType.value}/${courseId}`);
                    }
                    window.gio &&
                        window.gio('page.set', {
                            dep_id: courseDetail.value.depId,
                            course_id: Number(courseId)
                        });
                    loaded.value = true;
                    if (!isApp) {
                        let { shareImgName, shareTitle } = courseDetail.value;
                        weixinShare({
                            url: location.href,
                            desc: desc.value,
                            image: shareImgName,
                            title: shareTitle
                        });
                    }
                    nextTick(() => {
                        let dom = document.querySelector('.expertH');
                        let rem = Number(localStorage.getItem('rem') || 0);
                        let h = dom?.offsetHeight || 0;
                        expertBl.value = !((h * 100) / rem > 220);
                        // 设置高度
                        tabh = tabRef.value.offsetHeight;
                        top1 = detailOne.value.offsetTop;
                        nextTick(() => {
                            contentTop.value = tabRef.value.offsetTop - num;
                        });
                    });
                }
            });
        };
        getData();
        watch(() => props.updatePage, (n) => {
            if (n) {
                getData();
            }
        });
        // 进入课程
        const toDetail = () => {
            if (isApp) {
                goToStudy('album', courseId);
            }
            else {
                location.assign(`${hostPath}/course/album/${courseId}`);
            }
        };
        const toServe = () => {
            if (isApp) {
                jumpModuleApp({
                    type: 'video',
                    typeId: 'online_consulting',
                    dataId: courseId
                });
            }
            else {
                location.href = `${hostPath}/user/service?albumId=${courseId}`;
            }
        };
        const toLearn = () => {
            if (courseDetail.value.moduleType == 'open') {
                // goToStudy('album', courseDetail.value.albumId)
                toDetail();
                return;
            }
            if (courseDetail.value.isPay) {
                toDetail();
            }
            else {
                if (!userId) {
                    userLogin();
                    return;
                }
                let vipId = courseDetail.value.vipId;
                if (isApp) {
                    jumpModuleApp({
                        typeId: 'vip_member_open',
                        dataId: vipId
                    });
                }
                else {
                    location.href = `${hostPath}/open_vip?vipId=${vipId}`;
                }
            }
        };
        // 单独购买
        const buyOnly = () => {
            // 判断是否是 ios app 进入咨询页
            if (isApp && iOSPort()) {
                jumpModuleApp({
                    type: 'video',
                    typeId: 'online_consulting',
                    dataId: courseId
                });
            }
            else {
                if (!userId) {
                    userLogin();
                    return;
                }
                // 创建课程订单并跳转到订单支付页
                createAlbumOrder({ userId, albumId: Number(courseId), videoIds: '' }).then((res) => {
                    if (res.code == 200) {
                        if (isApp) {
                            jumpModuleApp({
                                typeId: 'h5',
                                url: `${hostPath}/learn/order/album/${res.data}`
                            });
                        }
                        else {
                            router.push({
                                path: `/order/album/${res.data}`
                            });
                        }
                    }
                });
            }
        };
        const tabs = ref([
            {
                id: 1,
                value: '简介'
            },
            {
                id: 2,
                value: '推荐'
            }
        ]);
        const remToPx = (n) => {
            var rem = localStorage.getItem('rem');
            return (n * Number(rem)) / 100;
        };
        const barHeight = ref('0.56rem');
        barHeight.value = getRemH() + 0.4 + 0.56 + 'rem';
        const appbar = getRemH() + 0.4 + 'rem';
        let rem = Number(localStorage.getItem('rem'));
        let num = Number((88 * rem) / 100);
        if (isApp && !isLiveOpen) {
            num = remToPx(parseFloat(barHeight.value)) * 100;
        }
        const tabId = ref(1);
        const selectTab = item => {
            tabId.value = item.id;
            var t = 0;
            if (isApp && !isLiveOpen) {
                tabh = num + tabRef.value.offsetHeight;
            }
            else {
                tabh = tabRef.value.offsetHeight;
            }
            if (item.id == 2) {
                top2 = detailTwo.value.offsetTop;
                t = top2 - tabh;
            }
            else if (item.id == 1) {
                t = contentTop.value;
            }
            window.scrollTo({
                top: t + 2
            });
        };
        const scrollTop = ref(0);
        const detailOne = ref();
        const detailTwo = ref();
        const tabRef = ref();
        let top1 = 0;
        let top2 = 0;
        let tabh = 0;
        const scroll = () => {
            scrollTop.value =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (isApp && !isLiveOpen) {
                tabh = num + tabRef.value.offsetHeight;
            }
            else {
                tabh = tabRef.value.offsetHeight;
            }
            top2 = detailTwo.value.offsetTop;
            if (scrollTop.value >= top2 - tabh) {
                tabId.value = 2;
            }
            else {
                tabId.value = 1;
            }
        };
        // 计算透明度
        const domOpacity = computed(() => {
            return scrollTop.value > 0 ? mathRound(scrollTop.value / 100, 1) : 1;
        });
        const contentTop = ref(0);
        onMounted(() => {
            window.addEventListener('scroll', scroll, false);
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', scroll, false);
        });
        const clickRecommend = data => {
            // 查看推荐
            return new Promise(resolve => {
                let { depName, albumName, albumId, moduleType } = courseDetail.value;
                recommendGIO({
                    departmentType: depName,
                    recommendedCarrier: 'course',
                    course_ID: albumId + '',
                    course_name: albumName,
                    moduleType: moduleType || 'vip',
                    ...data
                }).then(() => {
                    resolve(true);
                });
            });
        };
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(isApp) && !_unref(isLiveOpen))
                    ? (_openBlock(), _createBlock(AppShareItem, {
                        key: 0,
                        shareInfo: {
                            desc: _unref(desc),
                            image: _unref(bannerShare) ? shareInfo.value.image : courseDetail.value.shareImgName,
                            title: _unref(bannerShare) ? shareInfo.value.title : courseDetail.value.shareTitle,
                            url: _unref(bannerShare) ? shareInfo.value.url : ''
                        },
                        "page-title": scrollTop.value >= contentTop.value ? courseDetail.value.albumName : '',
                        color: scrollTop.value > 5 ? 'black' : 'white',
                        style: _normalizeStyle({
                            height: barHeight.value,
                            opacity: _unref(domOpacity),
                            'padding-top': appbar
                        }),
                        class: _normalizeClass({
                            inApp: _unref(isApp),
                            'white-bg': scrollTop.value > 5
                        })
                    }, null, 8, ["shareInfo", "page-title", "color", "style", "class"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Banner, {
                        "banner-style": bannerStyle,
                        autoplay: 3000,
                        listNum: banner.value.length,
                        list: banner.value,
                        numLayout: 'rightBottom'
                    }, {
                        swipeItem: _withCtx(({ item, key }) => [
                            _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                                [_directive_lazy, item.image]
                            ])
                        ]),
                        _: 1
                    }, 8, ["listNum", "list"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(courseDetail.value.albumName), 1),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("img", {
                                    src: courseDetail.value.expertImage,
                                    alt: ""
                                }, null, 8, _hoisted_9)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(courseDetail.value.expertName), 1),
                                _createElementVNode("div", _hoisted_12, _toDisplayString(courseDetail.value.expertHospitalName), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", {
                                onClick: _withModifiers(toDetail, ["stop"])
                            }, "进入课程", 8, _hoisted_14)
                        ])
                    ])
                ]),
                _createElementVNode("div", {
                    class: "tabWrapper",
                    ref: (_value, _refs) => {
                        _refs['tabRef'] = _value;
                        tabRef.value = _value;
                    }
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["tabBox p-lr32 border-box flexBox", {
                                fixed: scrollTop.value >= contentTop.value
                            }]),
                        style: _normalizeStyle({ top: (_unref(isApp) && !_unref(isLiveOpen)) ? barHeight.value : 0 })
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["tabItem p-lr16", { active: tabId.value == item.id }]),
                                onClick: _withModifiers(($event) => (selectTab(item)), ["stop"])
                            }, _toDisplayString(item.value), 11, _hoisted_15));
                        }), 256))
                    ], 6)
                ], 512),
                _createElementVNode("div", {
                    class: "contentWrapper border-box p-lr32 white-bg",
                    ref: (_value, _refs) => {
                        _refs['detailOne'] = _value;
                        detailOne.value = _value;
                    }
                }, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("p", {
                                class: _normalizeClass(["expertDescBox", { 'text-ell5': !expertBl.value }])
                            }, [
                                _createElementVNode("span", {
                                    class: "expertH",
                                    innerHTML: courseDetail.value.expertDescription?.replace(/(\r\n|\r|\n)/g, '<br /><br />')
                                }, null, 8, _hoisted_18)
                            ], 2),
                            _withDirectives(_createElementVNode("div", {
                                class: "btn themeColor font-28 font-w500",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (expertBl.value = true), ["stop"]))
                            }, " 展开 ", 512), [
                                [_vShow, !expertBl.value]
                            ])
                        ]),
                        (courseDetail.value.detailsImageName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                                    [_directive_lazy, courseDetail.value.detailsImageName]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ], 512),
                _createElementVNode("div", {
                    ref: (_value, _refs) => {
                        _refs['detailTwo'] = _value;
                        detailTwo.value = _value;
                    }
                }, [
                    _createVNode(CourseRecommend, {
                        "module-type": 'album',
                        "course-id": _unref(courseId),
                        loaded: loaded.value,
                        isLiveOpen: _unref(isLiveOpen),
                        onClickRecommend: clickRecommend
                    }, null, 8, ["course-id", "loaded", "isLiveOpen"])
                ], 512),
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", {
                            class: "serveBtn font-24 gray-6",
                            onClick: _withModifiers(toServe, ["stop"])
                        }, "咨询", 8, _hoisted_23),
                        _createElementVNode("div", {
                            class: _normalizeClass(["goBtn font-28", { isPay: courseDetail.value.isPay }]),
                            onClick: _withModifiers(toLearn, ["stop"])
                        }, [
                            (courseDetail.value.purchasable)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(courseDetail.value.moduleType == 'open' || courseDetail.value.isPay
                                    ? '去学习'
                                    : '尊享会员免费'), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(courseDetail.value.moduleType == 'open'
                                    ? '去学习'
                                    : courseDetail.value.isPayBtn), 1))
                        ], 10, _hoisted_24),
                        (courseDetail.value.purchasable && !courseDetail.value.isPay)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "buyBtn",
                                onClick: _withModifiers(buyOnly, ["stop"])
                            }, " 立即报名 ", 8, _hoisted_27))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
